export const paddingLeftPlugin = {
    id : 'paddingLeft',
    afterUpdate(chart) {
      const legend = chart.legend;
      legend.left += 80;
      for (const box of legend.legendHitBoxes) {
        box.left +=80;
      }
    }
  };
